import React from 'react';
import useGetUsersList from '../api/useGetUsersList';
import UserItem from './UserItem';
import { useSearchParams } from 'react-router-dom';
import NoResults from '../../../components/States/NoResults';
import Error from '../../../components/States/Error';
import Table from '../../../components/Table';
import LimitItems from '../../../components/LimitItems';
import SavedFilters from '../../../components/SavedFilters';
import { IAMListRole } from '../../IAM/types';

export const INVITE_STATUSES = [
    { id: 'INVITED', name: 'Invited' },
    { id: 'ACTIVE', name: 'Active' },
    { id: 'INVITE_EXPIRED', name: 'Invite Expired' },
    { id: 'DEACTIVATED', name: 'Deactivated' }
];

const UserList: React.FC<{ roles?: IAMListRole[] }> = ({ roles }) => {
    const [searchParams] = useSearchParams();
    const searchParam = searchParams.get('search') || '';
    const offset = searchParams.get('offset');
    const limit = searchParams.get('limit');
    const sort_dir = searchParams.get('sort_dir');
    const role = searchParams.get('role');
    const status = searchParams.get('status');

    const query = React.useMemo(() => {
        return {
            sort_by: 'email',
            sort_dir: sort_dir || 'DESC',
            ...(limit && { limit: +limit }),
            ...(searchParam.length && { search: encodeURIComponent(searchParam) }),
            ...(offset && { offset: +offset }),
            ...(role && { role }),
            ...(status && { status })
        };
    }, [searchParam, offset, limit, sort_dir, role, status]);

    const { data, isLoading, isError } = useGetUsersList(query);

    if (isError) {
        return <Error />;
    }

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1.6rem',
                    minHeight: '4rem',
                    marginBottom: '2.4rem',
                    justifyContent: 'space-between'
                }}
            >
                <SavedFilters storageKey="ep:saved-filters:users" />
                <LimitItems
                    isLoading={isLoading}
                    limit={limit ? +limit : 10}
                    offset={offset ? +offset : 0}
                    total_count={data?.total_count}
                />
            </div>

            {data?.items.length === 0 ? (
                <NoResults
                    search={searchParam}
                    hideSearchLabel={searchParam.length === 0}
                    searchSupportsLabel="name or email"
                />
            ) : (
                <Table
                    pagerData={data}
                    headerColumns={['Name', 'Role', 'Status']}
                    headerGridTemplateColumns={'3fr 1fr 1fr'}
                    loading={isLoading}
                >
                    {data?.items.map((item) => (
                        <UserItem
                            key={item.invite_id ?? item.external_user_id}
                            user={item}
                            roles={roles}
                        />
                    ))}
                </Table>
            )}
        </>
    );
};

export default UserList;
